/* eslint-disable import/prefer-default-export */
import SaleIconSmall from 'assets/storefront.svg';
import StorageIconSmall from 'assets/storage.svg';

export const destinationLoadTypeIcon = {
  STORAGE: StorageIconSmall,
  SALE: SaleIconSmall
};
